<template>
  <van-tabbar route :active-color="activeColor">
    <van-tabbar-item v-for="(item, index) of tabList" :key="index" replace :to="item.path" :name="index">
      <span>{{ item.name }}</span>
      <template #icon="props">
        <svg-icon :iconClass="item.icon" :style="{color: props.active ? activeColor : '#333333' }"></svg-icon>
        <!-- <img :src="props.active ? activeColor : item.icon.inactive" /> -->
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
// import tabbar from '@/router/routes/tabbarRoute.js'
export default {
  props: {
    activeColor: {
      type: String,
      default: '#DB1905',
    },
    tabList: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
    };
  },
  mounted () {
    window.onresize = () => {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.van-tabbar {
  height: 1rem;
}
</style>